(function () {
  'use strict';
  // Reuse the native Google & YouTube channel's OPEN-context tag. Never load/configure another tag.
  if (window.DDCFunnel) return;
  var measurement = 'G-ES59Q0VCF2', sent = Object.create(null);
  var names = ['ddc_routine_view','ddc_routine_cta','ddc_routine_start','ddc_routine_step','ddc_routine_complete','ddc_routine_cart_attempt','ddc_routine_cart_success','ddc_routine_cart_error','ddc_demo_play','ddc_demo_complete','ddc_proof_click','ddc_product_detail'];
  function excluded() {
    var s = window.Shopify || {}, query = new URLSearchParams(window.location.search);
    return !!(s.designMode || s.inspectMode || (s.theme && s.theme.role && s.theme.role !== 'main') || query.has('preview_theme_id') || query.has('preview_key') || /\.shopifypreview\.com$/i.test(window.location.hostname) || document.getElementById('PBarNextFrame'));
  }
  function permitted() {
    try { return !excluded() && window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function cleanUrl(value) {
    if (!value) return '';
    try { var u = new URL(value, window.location.origin); return u.origin + u.pathname; }
    catch (_) { return ''; }
  }
  function track(name, detail) {
    if (names.indexOf(name) === -1 || !permitted() || typeof window.gtag !== 'function') return false;
    var parameters = {send_to:measurement, ddc_funnel_version:'2026_10_v2', page_location:cleanUrl(window.location.href)};
    // Do not pass through objects, answer values, skin types, free text, emails, IDs, prices, or recommendation names.
    detail = detail || {};
    if (name === 'ddc_routine_cta') {
      if (['product','article'].indexOf(detail.cta_placement) === -1) return false;
      parameters.cta_placement = detail.cta_placement;
    }
    if (name === 'ddc_routine_step') {
      if (!Number.isInteger(detail.step_number) || detail.step_number < 1 || detail.step_number > 5) return false;
      parameters.step_number = detail.step_number;
    }
    if (['ddc_routine_cart_attempt','ddc_routine_cart_success','ddc_routine_cart_error'].indexOf(name) !== -1) {
      if (Number.isInteger(detail.product_count) && detail.product_count >= 1 && detail.product_count <= 3) parameters.product_count = detail.product_count;
      if (['one_time','subscription'].indexOf(detail.purchase_option) !== -1) parameters.purchase_option = detail.purchase_option;
      if (name === 'ddc_routine_cart_error' && ['unavailable','network','cart_rejected','invalid_response','unknown'].indexOf(detail.error_type) !== -1) parameters.error_type = detail.error_type;
    }
    if (name === 'ddc_demo_play' || name === 'ddc_demo_complete') {
      if (typeof detail.video_id !== 'string' || !/^[a-z0-9][a-z0-9_-]{0,79}$/.test(detail.video_id)) return false;
      parameters.video_id = detail.video_id;
    }
    if (name === 'ddc_product_detail') {
      if (['ingredients','directions','delivery'].indexOf(detail.detail_type) === -1) return false;
      parameters.detail_type = detail.detail_type;
    }
    if (name === 'ddc_proof_click') {
      if (['facebook_store_reviews','facebook_community','product_reviews'].indexOf(detail.proof_type) === -1) return false;
      parameters.proof_type = detail.proof_type;
    }
    var key = name + ':' + (parameters.step_number || parameters.video_id || parameters.detail_type || parameters.proof_type || parameters.cta_placement || '');
    var repeatable = name === 'ddc_routine_cart_attempt' || name === 'ddc_routine_cart_error';
    if (sent[key] && !repeatable) return false;
    if (name.indexOf('ddc_routine_') === 0 && name !== 'ddc_routine_view' && name !== 'ddc_routine_cta' && document.querySelector('[data-routine-finder]')) track('ddc_routine_view');
    if (new URLSearchParams(window.location.search).get('ddc_analytics_debug') === '1') {
      parameters.debug_mode = true;
      parameters.ddc_test = 1;
    }
    // Query strings and referrer fragments can contain form content; keep them out of custom hits.
    parameters.page_referrer = cleanUrl(document.referrer);
    try { window.gtag('event', name, parameters); sent[key] = true; return true; }
    catch (_) { return false; }
  }
  window.DDCFunnel = Object.freeze({track:track});
  // Shopify's Allowed method combines regional requirements and the visitor's actual consent.
  // Load its API, but never grant/change consent, write cookies, or queue pre-consent events.
  if (!window.Shopify || excluded()) return;
  if (!window.Shopify.customerPrivacy && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function () { viewFinder(); });
  }
  var finder = document.querySelector('[data-routine-finder]');
  function viewFinder() {
    if (document.querySelector('[data-routine-finder]') && document.visibilityState !== 'hidden') track('ddc_routine_view');
  }
  viewFinder();
  document.addEventListener('visitorConsentCollected', viewFinder);
  document.addEventListener('visibilitychange', viewFinder);
  window.addEventListener('pageshow', viewFinder);
  window.setTimeout(viewFinder, 1000);
  window.setTimeout(viewFinder, 3000);
  if (finder && finder.getAttribute('data-quiz-version') !== '2026-10-v2') {
    finder.addEventListener('change',function (event) {
      if (event.target.matches('[data-quiz-form] input[type="radio"]')) track('ddc_routine_start');
    });
    // Observe progress and result visibility only; never read a radio's name, value, label, or answer.
    var form = finder.querySelector('[data-quiz-form]'), progress = finder.querySelector('progress'), results = finder.querySelector('[data-quiz-results]');
    if (form && progress && results) {
      form.addEventListener('submit',function () {
        var before = Number(progress.value);
        window.setTimeout(function () {
          if (Number(progress.value) > before || !results.hidden) track('ddc_routine_step',{step_number:before});
          if (!results.hidden) track('ddc_routine_complete');
        },0);
      },true);
    }
  }
  document.addEventListener('play',function (event) {
    var video = event.target;
    if (video.matches && video.matches('video[data-ddc-product-video]')) track('ddc_demo_play',{video_id:video.getAttribute('data-ddc-video-id')});
  },true);
  document.addEventListener('ended',function (event) {
    var video = event.target;
    if (video.matches && video.matches('video[data-ddc-product-video]')) track('ddc_demo_complete',{video_id:video.getAttribute('data-ddc-video-id')});
  },true);
  document.addEventListener('click',function (event) {
    var target = event.target.closest && event.target.closest('[data-ddc-proof-click]');
    if (target) track('ddc_proof_click',{proof_type:target.getAttribute('data-ddc-proof-click')});
    var routineCta = event.target.closest && event.target.closest('[data-ddc-routine-cta]');
    if (routineCta) track('ddc_routine_cta',{cta_placement:routineCta.getAttribute('data-ddc-routine-cta')});
  });
  document.addEventListener('toggle',function (event) {
    var target = event.target;
    if (target.matches && target.matches('details[data-ddc-detail-type]') && target.open) track('ddc_product_detail',{detail_type:target.getAttribute('data-ddc-detail-type')});
  },true);
}());
